<section class="combustivel-tab">
  <!-- ════════════════════════════════════════════════════════════════════════
       1. TOP KPI CARDS (4 INDICADORES DO MÊS CORRENTE)
       ════════════════════════════════════════════════════════════════════════ -->
  <div class="kpi-grid-row">
    <!-- Card 1: Total Gasto no Mês -->
    <div class="kpi-fuel-card">
      <span class="kfc-label">Total {{ mesAtualNome }}</span>
      <strong class="kfc-value">AOA {{ formatKz(totalGastoMes) }}</strong>
    </div>

    <!-- Card 2: Litros Abastecidos -->
    <div class="kpi-fuel-card">
      <span class="kfc-label">Litros Abastecidos</span>
      <strong class="kfc-value">{{ totalLitrosMes }} L</strong>
    </div>

    <!-- Card 3: Km Percorridos -->
    <div class="kpi-fuel-card">
      <span class="kfc-label">Km Percorridos</span>
      <strong class="kfc-value">{{ formatKm(kmPercorridosMes) }} km</strong>
    </div>

    <!-- Card 4: Consumo Médio -->
    <div class="kpi-fuel-card">
      <span class="kfc-label">Consumo Médio</span>
      <strong class="kfc-value">{{ consumoMedio }} L/100km</strong>
    </div>
  </div>

  <!-- ════════════════════════════════════════════════════════════════════════
       2. TABELA DE REGISTOS DE ABASTECIMENTO
       ════════════════════════════════════════════════════════════════════════ -->
  <div class="registos-section">
    <div class="rs-header">
      <h3 class="rs-title">Registos de Abastecimento</h3>
    </div>

    <div class="fuel-table-container">
      <table class="fuel-table">
        <thead>
          <tr>
            <th>DATA</th>
            <th>LITROS</th>
            <th>CUSTO (AOA)</th>
            <th>KM</th>
            <th>POSTO</th>
            <th>MOTORISTA</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of registos">
            <td class="cell-date">{{ formatDate(row.data) }}</td>
            <td class="cell-litros">
              <strong>{{ row.litros }} L</strong>
            </td>
            <td class="cell-custo">{{ formatKz(row.custo) }}</td>
            <td class="cell-km">{{ formatKm(row.quilometragem) }}</td>
            <td class="cell-posto">{{ row.postoCombustivel }}</td>
            <td class="cell-motorista">{{ row.motorista }}</td>
          </tr>
          <tr *ngIf="registos.length === 0">
            <td colspan="6" class="cell-empty">
              Nenhum registo de abastecimento para esta viatura.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Botão de Ação -->
    <div class="rs-footer-actions">
      <button
        type="button"
        class="btn-web-primary"
        (click)="openCreate()"
      >
        <i class="ri-add-line"></i> Registar Abastecimento
      </button>
    </div>
  </div>

  <!-- ════════════════════════════════════════════════════════════════════════
       3. DRAWER DE REGISTO DE ABASTECIMENTO
       ════════════════════════════════════════════════════════════════════════ -->
  <p-drawer
    [(visible)]="drawerVisible"
    position="right"
    [modal]="true"
    [blockScroll]="true"
    styleClass="combustivel-drawer"
    header="Registar Abastecimento"
    (onHide)="closeDrawer()"
  >
    <div class="drawer-form-container">
      <div class="sp-form-grid">
        <!-- Data do Abastecimento -->
        <div class="sp-form-group">
          <label>Data <span class="required">*</span></label>
          <p-datepicker
            [(ngModel)]="form.data"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            appendTo="body"
            styleClass="w-full"
          />
        </div>

        <!-- Tipo de Combustível -->
        <div class="sp-form-group">
          <label>Combustível <span class="required">*</span></label>
          <p-select
            [(ngModel)]="form.tipoCombustivel"
            [options]="tiposCombustivel"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecione..."
            (onChange)="calcularCustoSugerido()"
            styleClass="w-full"
          />
        </div>

        <!-- Litros Abastecidos -->
        <div class="sp-form-group">
          <label>Litros Abastecidos <span class="required">*</span></label>
          <p-inputNumber
            [(ngModel)]="form.litros"
            [min]="1"
            placeholder="Ex: 80"
            (onBlur)="calcularCustoSugerido()"
            styleClass="w-full"
          />
        </div>

        <!-- Custo Total (AOA) -->
        <div class="sp-form-group">
          <label>Custo Total (AOA) <span class="required">*</span></label>
          <p-inputNumber
            [(ngModel)]="form.custo"
            mode="currency"
            currency="AOA"
            locale="pt-AO"
            [minFractionDigits]="0"
            [maxFractionDigits]="0"
            placeholder="0 Kz"
            styleClass="w-full"
          />
        </div>

        <!-- Km no Momento do Abastecimento -->
        <div class="sp-form-group full-width">
          <label>Quilometragem (Km Atual) <span class="required">*</span></label>
          <p-inputNumber
            [(ngModel)]="form.quilometragem"
            [min]="0"
            placeholder="Ex: 45230"
            styleClass="w-full"
          />
          <small class="field-hint">
            <i class="ri-information-line"></i> Ao confirmar, a quilometragem atual da viatura será atualizada para este valor.
          </small>
        </div>

        <!-- Posto de Combustível -->
        <div class="sp-form-group">
          <label>Posto de Combustível <span class="required">*</span></label>
          <p-select
            [(ngModel)]="form.postoCombustivel"
            [options]="postosSugeridos"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecione o posto..."
            styleClass="w-full"
          />
        </div>

        <!-- Posto Personalizado (se selecionado "Outro") -->
        <div class="sp-form-group" *ngIf="form.postoCombustivel === 'Outro'">
          <label>Nome do Posto <span class="required">*</span></label>
          <input
            pInputText
            [(ngModel)]="form.postoCustom"
            placeholder="Ex: Sonangol Kilamba"
            class="w-full"
          />
        </div>

        <!-- Motorista Responsável -->
        <div class="sp-form-group">
          <label>Motorista Responsável</label>
          <input
            pInputText
            [(ngModel)]="form.motorista"
            placeholder="Ex: João Manuel"
            class="w-full"
          />
        </div>

        <!-- Observações -->
        <div class="sp-form-group full-width">
          <label>Observações</label>
          <textarea
            pTextarea
            [(ngModel)]="form.observacoes"
            rows="2"
            placeholder="Notas adicionais sobre o abastecimento..."
            class="w-full"
          ></textarea>
        </div>

        <!-- Comprovativo / Fatura -->
        <div class="sp-form-group full-width">
          <label>Fatura / Comprovativo de Pagamento</label>
          <div class="doc-upload-box">
            <label class="doc-upload-trigger" *ngIf="!selectedFile">
              <input
                type="file"
                (change)="onFileSelected($event)"
                hidden
              />
              <i class="ri-receipt-line"></i>
              <span>Carregar fatura do posto (PDF ou Imagem)</span>
            </label>
            <div class="file-chip" *ngIf="selectedFile">
              <i class="ri-file-text-line"></i>
              <span class="file-name">{{ selectedFile.name }}</span>
              <button type="button" (click)="removeFile()">
                <i class="ri-close-line"></i>
              </button>
            </div>
          </div>
          <small class="field-hint">O comprovativo é refletido na tab Documentação da viatura.</small>
        </div>
      </div>

      <div class="drawer-actions">
        <button
          type="button"
          class="btn-web-secondary"
          (click)="closeDrawer()"
          [disabled]="saving"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="btn-web-primary"
          (click)="salvarRegisto()"
          [disabled]="saving"
        >
          <i class="ri-check-line"></i>
          {{ saving ? 'A guardar...' : 'Confirmar Abastecimento' }}
        </button>
      </div>
    </div>
  </p-drawer>
</section>
